import { render, staticRenderFns } from "./ModalCriteria.vue?vue&type=template&id=e10c8b1c&scoped=true&"
import script from "./ModalCriteria.vue?vue&type=script&lang=js&"
export * from "./ModalCriteria.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e10c8b1c",
  null
  
)

export default component.exports